import { useEffect, useRef, useState } from "react";
import AnnoncesCard from "../AnnoncesCard";
import ListingsListCards from "components/v2/Listings/ListingsListCards";
const ViewportOnlyCardComponent = (props) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const dynamicComponentRef = useRef(null);
  const [allDone, setAllDone] = useState(
    props.position ? (props.position < 5 ? true : false) : false
  );

  useEffect(() => {
    let isMounted = true; // Flag to keep track of component mount status
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    const element = document.getElementById(props.id);
    if (element) observer.observe(element);

    // Cleanup function
    return () => {
      isMounted = false;
      if (element) observer.unobserve(element);
    };
  }, [props.id]);

  useEffect(() => {
    let isMounted = true; // Flag to keep track of component mount status

    if (isIntersecting) {
      if (isMounted) {
        setAllDone(true);
        dynamicComponentRef.current = AnnoncesCard;
      }
    }

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [isIntersecting]);
  useEffect(() => {}, [dynamicComponentRef, allDone]);
  return allDone ? (
    <>
      {props.mapVsList == "MAP" ? (
        <div className={props.className} key={props.position}>
          <AnnoncesCard {...props} />
        </div>
      ) : (
        <ListingsListCards priority={props.priority} {...props} />
      )}
    </>
  ) : (
    <></>
  );
};

export default ViewportOnlyCardComponent;
